package dev.terrakok.mapitan.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import dev.terrakok.mapitan.ui.Icons

enum class Mode {
    Cursor,
    Pin,
    Track,
    Area,
    Text
}


private data class ToolDef(
    val mode: Mode,
    val icon: ImageVector,
    val label: String,
    val keyHint: String,
)

private val TOOLS: List<ToolDef> = listOf(
    ToolDef(Mode.Cursor, Icons.Cursor, "Cursor", "1"),
    ToolDef(Mode.Pin, Icons.Pin, "Pin", "2"),
    ToolDef(Mode.Track, Icons.Track, "Track", "3"),
    ToolDef(Mode.Area, Icons.Area, "Area", "4"),
    ToolDef(Mode.Text, Icons.Text, "Text", "5"),
)

@Composable
fun ToolBar(
    currentMode: Mode,
    onModeChanged: (Mode) -> Unit,
    lockIsClosed: Boolean,
    onLockClicked: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Card(
        modifier = modifier,
        shape = MaterialTheme.shapes.small,
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surface,
        ),
        elevation = CardDefaults.cardElevation(6.dp),
    ) {
        Row(
            modifier = Modifier.padding(4.dp),
            horizontalArrangement = Arrangement.spacedBy(2.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            TOOLS.forEach { tool ->
                val isSelected = currentMode == tool.mode
                IconButton(
                    onClick = { onModeChanged(tool.mode) },
                    modifier = Modifier.size(36.dp),
                    shape = MaterialTheme.shapes.small,
                    colors = IconButtonDefaults.iconButtonColors(
                        containerColor = if (isSelected)
                            MaterialTheme.colorScheme.primaryContainer
                        else
                            MaterialTheme.colorScheme.surface,
                    )
                ) {
                    Box(
                        modifier = Modifier.fillMaxSize()
                    ) {
                        Icon(
                            imageVector = tool.icon,
                            contentDescription = tool.label,
                            tint = if (isSelected)
                                MaterialTheme.colorScheme.primary
                            else
                                MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.size(18.dp).align(Alignment.Center),
                        )
                        Text(
                            text = tool.keyHint,
                            style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold),
                            modifier = Modifier.align(Alignment.BottomStart).padding(start = 3.dp),
                        )
                    }
                }
            }

            VerticalDivider(
                modifier = Modifier.height(12.dp).padding(horizontal = 2.dp)
            )

            IconButton(
                onClick = { onLockClicked() },
                modifier = Modifier.size(36.dp),
                shape = MaterialTheme.shapes.small
            ) {
                Box(
                    modifier = Modifier.fillMaxSize()
                ) {
                    Icon(
                        imageVector = if (lockIsClosed) Icons.LockClosed else Icons.LockOpen,
                        contentDescription = "Tool lock",
                        tint = if (lockIsClosed)
                            MaterialTheme.colorScheme.primary
                        else
                            MaterialTheme.colorScheme.primary.copy(alpha = 0.5f),
                        modifier = Modifier.size(18.dp).align(Alignment.Center),
                    )
                    Text(
                        text = "Q",
                        style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold),
                        modifier = Modifier.align(Alignment.BottomStart).padding(start = 3.dp),
                    )
                }
            }
        }
    }
}